import { Box, Link, Text } from '@betterment/samba-react';
import { Flash } from '@betterment/style-closet-react';

import { SUPPORT_EMAIL } from '../constants';

export type SuspendedObject = 'account' | 'goal';

type AccountSuspendedBannerProps = {
  suspendedObject?: SuspendedObject;
};

export const AccountSuspendedBanner: React.FC<React.PropsWithChildren<AccountSuspendedBannerProps>> = ({
  suspendedObject = 'account',
}) => {
  return (
    <Box
      css={{
        marginBottom: 'space.300',
      }}
    >
      <Flash variant="error" mt="0">
        <Text as="p">
          Your {suspendedObject} is suspended. We need more information about your account to proceed. Please{' '}
          <Link href={`mailto:${SUPPORT_EMAIL}`}>contact us</Link> before continuing with this transaction.
        </Text>
      </Flash>
    </Box>
  );
};
